
/* DylonT 100925, from perplex, created this custom-menu.js object for attempting to have main menu appear on hover instead of click */


document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth > 990) {
    const menuItems = document.querySelectorAll('.header__inline-menu details');
    menuItems.forEach(menuItem => {
      menuItem.addEventListener('mouseenter', () => {
        if (!menuItem.hasAttribute('open')) {
          menuItem.setAttribute('open', '');
        }
      });
      menuItem.addEventListener('mouseleave', () => {
        if (menuItem.hasAttribute('open')) {
          menuItem.removeAttribute('open');
        }
      });
    });
  }
});

/* end of DT edit */